import type { NavigationGuard } from 'vue-router';
import { fetchCurrentUser } from '@/modules/current-user/api';

export const unrestrictedSupplierAccessGuard: NavigationGuard = async (_to, _from, next) => {
  const { data: user } = await fetchCurrentUser();
  if (user.restrictSupplierAccess) {
    return next({ name: 'client-reporting' });
  }
  return next();
};
